export default __webpack_public_path__ + "static/media/Twitter Icon.6eb4e5c8.svg";